// material-ui
import logoIcon from 'assets/images/logo.png';

// ==============================|| LOGO ICON SVG ||============================== //

const LogoIcon = () => <img src={logoIcon} alt="Kazenergy" width="40" />;

export default LogoIcon;
